import { useState } from "react";
import { Table } from "@/features/Table";
import { type TimeSerieFile, time_serie_files_columns } from "./columns";
import {
  type FilterTimeSerieFilesSchema,
  FilterTimeSerieFiles,
} from "./filter";
import { UploadNew } from "./new";
import UploadPopover from "@/components/UploadPopover";
import { useQueryClient } from "@tanstack/react-query";

const client = "etl-quantilia";
const table_name = "time_serie_files";

export const TimeSerieFilesTable = () => {
  const [files, setFiles] = useState<File[]>([]);
  const [selectedConfig, setSelectedConfig] = useState<string | null>(null);
  const [selectedConfigId, setSelectedConfigId] = useState<number | null>(null);

  const QueryClient = useQueryClient();
  const refreshList = async () => {
    // In v5, this invalidates all queries whose key starts with the prefix
    await QueryClient.invalidateQueries({
      queryKey: [client, table_name, "get"],
    });
  };
  return (
    <Table<TimeSerieFile, FilterTimeSerieFilesSchema>
      label="Time Serie Files"
      client={client}
      table_name={table_name}
      columns={time_serie_files_columns}
      filter={<FilterTimeSerieFiles />}
      disable_translations_request={true}
      download_button={false}
      new_item={
        <UploadPopover
          uploader={({ setIsOpen }) => (
            <UploadNew
              setIsOpen={setIsOpen}
              files={files}
              setFiles={setFiles}
              selectedConfig={selectedConfig}
              setSelectedConfig={setSelectedConfig}
              selectedConfigId={selectedConfigId}
              setSelectedConfigId={setSelectedConfigId}
              onSuccess={async () => {
                await refreshList();
              }}
            />
          )}
        />
      }
    />
  );
};
